// extracted by mini-css-extract-plugin
module.exports = {"--grid-sm-breakpoint":"768px","--grid-md-breakpoint":"1024px","--grid-lg-breakpoint":"1367px"};